import { ValidationError } from 'yup';

interface Errors {
  [key: string]: string;
}

export default function (err: ValidationError): Record<string, any> {
  const validationErrors: Errors = {};

  err.inner.forEach(error => {
    validationErrors[error.path] = error.message;
  });
  return validationErrors;
}
